import { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import LogisticServiceDetailsTab1General from '../../LogisticServiceDetailsTab1General/LogisticServiceDetailsTab1General';
import LogisticServiceDetailsTab2Locations from '../../LogisticServiceDetailsTab2Locations/LogisticServiceDetailsTab2Locations';
import LogisticServiceDetailsTab3Tools from '../../LogisticServiceDetailsTab3Tools/LogisticServiceDetailsTab3Tools';
import { IlogisticServiceDetails } from '../../../../../../types/services';
import BillingDataTab from '../../../../../../components/BillingDataTab/BillingDataTab';
import { ILogisticServiceHistory, TLogisticServiceStatusName } from '../../../../../../types/suscription/history.types';
import LogisticServiceDetailsTab4History from '../../LogisticServiceDetailsTab4History/LogisticServiceDetailsTab4History';

import './LogisticServiceDetailsTabs.scss';

const LogisticServiceDetailsTabs = ({
  logisticServiceData,
  logisticServiceHistoryData,
  handleTabSelectionCallback,
  updateDataCallback,
  updateWithoutLoader
}: {
  logisticServiceData: IlogisticServiceDetails;
  logisticServiceHistoryData: ILogisticServiceHistory[];
  handleTabSelectionCallback: (newTabData: IlogisticServiceDetailsTab) => void;
  updateDataCallback: () => Promise<void>;
  updateWithoutLoader: () => Promise<void>;
}) => {
  const { push } = useHistory();
  const { state }: { state: { initialTab: number } } = useLocation();
  const [currentTab, setCurrentTab] = useState(state?.initialTab ?? 0);

  const { initialTab = 0 } = state || {};
  const includePurchaseOrderSection = !!logisticServiceData?.purchaseOrder || !!logisticServiceData?.requiresPO;
  const logisticServiceStatusName = logisticServiceData?.statusName as TLogisticServiceStatusName;

  const switchTab = (tabId: number) => {
    if (currentTab === tabId) return;
    setCurrentTab(tabId);
    push(`/logistic-service/details/${logisticServiceData?.id}`, {
      initialTab: tabId
    });
  };

  const logisticServiceDetailsViewTabsList = [
    {
      tabId: 0,
      action: () => switchTab(0),
      tabName: 'General',
      tabComponent: (
        <LogisticServiceDetailsTab1General
          logisticServiceData={logisticServiceData || {}}
          updateDataCallback={updateDataCallback}
          updateWithoutLoader={updateWithoutLoader}
        />
      )
    },
    {
      tabId: 1,
      action: () => switchTab(1),
      tabName: 'Ubicaciones',
      tabComponent: (
        <LogisticServiceDetailsTab2Locations
          logisticServiceData={logisticServiceData || {}}
          updateDataCallback={updateDataCallback}
          updateWithoutLoader={updateWithoutLoader}
        />
      )
    },
    {
      tabId: 2,
      action: () => switchTab(2),
      tabName: 'Herramientas',
      tabComponent: (
        <LogisticServiceDetailsTab3Tools
          logisticServiceData={logisticServiceData || {}}
          updateDataCallback={updateDataCallback}
        />
      )
    },
    {
      tabId: 3,
      action: () => switchTab(3),
      tabName: 'Facturación',
      tabComponent: (
        <BillingDataTab
          logisticServiceData={logisticServiceData}
          billingData={logisticServiceData?.billingData}
          billingCountry={logisticServiceData?.billingCountry}
          updateWithoutLoader={updateWithoutLoader}
          includePurchaseOrderSection={includePurchaseOrderSection}
        />
      )
    },
    {
      tabId: 4,
      action: () => switchTab(4),
      tabName: 'Historial',
      tabComponent: logisticServiceStatusName ? (
        <LogisticServiceDetailsTab4History
          logisticServiceHistoryData={logisticServiceHistoryData}
          logisticServiceStatusName={logisticServiceStatusName}
        />
      ) : (
        <></>
      )
    }
  ];

  useEffect(() => {
    const currentTabData = logisticServiceDetailsViewTabsList[currentTab];
    handleTabSelectionCallback(currentTabData);
  }, [currentTab, logisticServiceData?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setCurrentTab(initialTab);
  }, [initialTab]);

  return (
    <div className="LogisticServiceDetailsTabs">
      {logisticServiceDetailsViewTabsList.map(tab => {
        const tabClassname = `logisticServiceDetailsTab ${tab?.tabId === currentTab ? 'active' : 'notActive'}`;
        return (
          <div className={tabClassname} key={`tab${tab.tabId}`} onClick={tab.action}>
            <div className="tabName">{tab.tabName}</div>
          </div>
        );
      })}
    </div>
  );
};

export default LogisticServiceDetailsTabs;

export interface IlogisticServiceDetailsTab {
  tabId: number;
  action: () => void;
  tabName: string;
  tabComponent: JSX.Element;
}
